/**
 * Free Shipping Progress Bar - Dynamic Updates
 * Subscribes to cart updates and refreshes the progress bar
 */

(function() {
  // Prevent duplicate initialization if script is loaded multiple times
  if (window.freeShippingProgressInitialized) return;
  window.freeShippingProgressInitialized = true;

  const FREE_SHIPPING_THRESHOLD = 5000; // $50 in cents

  function updateProgressBars(subtotal) {
    const progressBars = document.querySelectorAll('.free-shipping-progress');
    if (progressBars.length === 0) return;

    const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal);
    const percentage = Math.min(100, (subtotal / FREE_SHIPPING_THRESHOLD) * 100);

    progressBars.forEach(bar => {
      // Update the data attribute
      bar.dataset.subtotal = subtotal;

      // Update the message
      const messageEl = bar.querySelector('.free-shipping-progress__message');
      if (messageEl) {
        if (remaining > 0) {
          const formattedRemaining = (remaining / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
          messageEl.innerHTML = `<span class="free-shipping-progress__amount">${formattedRemaining}</span> away from free US shipping`;
          messageEl.classList.remove('free-shipping-progress__message--complete');
        } else {
          messageEl.innerHTML = 'Free US shipping<span aria-hidden="true"> ✓</span><span class="visually-hidden"> unlocked</span>';
          messageEl.classList.add('free-shipping-progress__message--complete');
        }
      }

      // Update the progress bar width (CSS handles positioning and colors)
      const fillBar = bar.querySelector('.free-shipping-progress__bar');
      if (fillBar) {
        fillBar.style.width = percentage + '%';
      }

      // Update ARIA attributes
      const container = bar.querySelector('.free-shipping-progress__bar-container');
      if (container) {
        container.setAttribute('aria-valuenow', subtotal);
        const formattedSubtotal = (subtotal / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        const formattedThreshold = (FREE_SHIPPING_THRESHOLD / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        container.setAttribute('aria-label', `Free shipping progress: ${formattedSubtotal} of ${formattedThreshold}`);
      }
    });
  }

  // Fetch actual cart data and update progress bars
  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart && typeof cart.items_subtotal_price !== 'undefined') {
          updateProgressBars(cart.items_subtotal_price);
        }
      })
      .catch(err => console.error('Error fetching cart:', err));
  }

  function initSubscription() {
    // Subscribe to cart updates using Shopify's pub/sub
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        // Always fetch fresh cart data since the event data may not include subtotal
        fetchCartAndUpdate();
      });
      return true;
    }
    return false;
  }

  // Try to subscribe immediately
  if (!initSubscription()) {
    // If pub/sub not ready, wait for DOMContentLoaded
    document.addEventListener('DOMContentLoaded', () => {
      if (!initSubscription()) {
        // Still not ready, try again after a short delay
        setTimeout(initSubscription, 100);
        setTimeout(initSubscription, 500);
        setTimeout(initSubscription, 1000);
      }
    });
  }

  // Also listen for custom cart events
  document.addEventListener('cart:updated', () => {
    fetchCartAndUpdate();
  });
})();
